export const dataTable = [];
export const metaData = {
  mobile: false,
  user: {},
  dataTableName: 'task',
  projectList: {},
  developerList: {},
  dataTable: {},
  tables: {},
};

export const resetDataTable = () => {
  dataTable.splice(0);
};
